import { ApiService } from "../../services/api.service";
import Cookies from "universal-cookie";
import { FormEvent, useEffect, useRef, useState } from "react";
import PageLoading from "../PageLoading/PageLoading";
import { useOutletContext } from "../../OutletContext";
import Swal from "sweetalert2";
import { adminPermissionsType } from "../../types";
import { Divider, Typography } from "@mui/material";

const ChangePassword = () => {
    const cookies = new Cookies(null, {path: '/'});
    const [loading, setLoading] = useState<boolean>(false);
    const context = useOutletContext();
    const [permissions, setPermissions] = useState<adminPermissionsType>({member: false, deposit_scb: false, promotion: false, create_admin: false, withdraw_transactions: false, report_all: false, report_all_data: false, report_click: false, settings: false, deposit_transactions: false, managelotto: false, manange_bank_account: false});
    
    const curPasswordRef = useRef<HTMLInputElement>(null);
    const newPasswordRef = useRef<HTMLInputElement>(null);
    const conNewPasswordRef = useRef<HTMLInputElement>(null);
    const otpRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        const tmp_permissions: adminPermissionsType | null = context;
        if(tmp_permissions)
        {
            setPermissions(tmp_permissions);
        }
    }, []);

    const handleRequest = async (e: FormEvent) => {
        e.preventDefault();

        setLoading(true);
        try {
            if(
                !curPasswordRef.current ||
                !newPasswordRef.current ||
                !conNewPasswordRef.current ||
                !otpRef.current
            )
            {
                return;
            }

            const current_password = curPasswordRef.current.value.trim();
            const new_password = newPasswordRef.current.value.trim();
            const confirm_new_password = conNewPasswordRef.current.value.trim();
            const otp = otpRef.current.value.trim();
            if(new_password === '' || confirm_new_password === '')
            {
                Swal.fire({
                    icon: 'error',
                    title: 'Notification',
                    text: 'Please input new password !'
                });
            }
            else
            {
                const service = new ApiService();
                const request = await service.requestChangePassword(cookies.get('access_token'), current_password, new_password, confirm_new_password, otp);

                if(request.data.status_code === 200)
                {
                    Swal.fire({
                        icon: 'success',
                        title: 'Notification',
                        text: 'Change password success',
                    });
                }
                else
                {
                    Swal.fire({
                        icon: 'error',
                        title: 'Notification',
                        text: `Request payin fail (${request.data.status_code} - ${request.data.message})`
                    });
                }
            }
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    }

    return (
        <>
            {
                <PageLoading loading={loading} />
            }
            <>
                <div className="col-12 mb-3">
                    <div className="card">
                        <div className="card-body">
                            <Typography component={'h1'} fontSize={22}>
                                Change password <small>(Username: {cookies.get('username')})</small>
                            </Typography>
                            <Divider sx={{ mb: 1 }} />
                            <form id="formRequestChangePassword" className="mb-3" onSubmit={handleRequest}>
                                <div className="mb-1">
                                    <label htmlFor="cur_password" className="form-label"
                                        style={{ color: '#51659e' }}>
                                        Current password
                                    </label>
                                    <input type="password" className="form-control" id="cur_password" name="cur_password"
                                        placeholder="Current password" ref={curPasswordRef} />
                                </div>
                                <div className="mb-1">
                                    <label htmlFor="new_password" className="form-label"
                                        style={{ color: '#51659e' }}>
                                        New password
                                    </label>
                                    <input type="password" className="form-control" id="new_password" name="new_password"
                                        placeholder="New password" ref={newPasswordRef} />
                                </div>
                                <div className="mb-1">
                                    <label htmlFor="confirm_new_password" className="form-label"
                                        style={{ color: '#51659e' }}>
                                        Confirm new password
                                    </label>
                                    <input type="password" className="form-control" id="confirm_new_password" name="confirm_new_password"
                                        placeholder="Confirm new password" ref={conNewPasswordRef} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="otp" className="form-label"
                                        style={{ color: '#51659e' }}>
                                        Authenticator
                                    </label>
                                    <input type={'text'} id="otp" className="form-control"
                                        name="otp" placeholder="Authenticator" ref={otpRef} />
                                </div>
                                <button className="btn btn-primary d-grid w-100" type="submit">Change password</button>
                            </form>
                        </div>
                    </div>
                </div>
            </>
        </>
    )
}

export default ChangePassword;